export enum PanelIds {
  Panel1 = 'panel-1',
  Panel2 = 'panel-2',
  Panel3 = 'panel-3',
  Panel4 = 'panel-4',
  Panel5 = 'panel-5',
}

export enum ServiceCategoryIds {
  ServicesId = 2,
  GlassId = 5,
  BodyWorkId = 6,
  OtherComplainId = 7
}
export enum ServiceIds {
  ServiceId = 6,
  BodyRepair = 63,
  StoneChip = 48
}

export enum WeekDays {
  Sunday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6
}

export enum AppRoutes {
  Booking = 'appointment-booking',
  Summary = 'summary',
  CookiePolicy = 'cookiePolicy'
}
export enum IsRentalActive{
  isRentalActive = 1
}
export enum IsOTPVerify{
  isOtpVerify = 0
}